import classnames from 'classnames'
import * as React from 'react'

import BarChart from '../futures/components/BarChart'
import { AdTag, getInvestingChannelPage } from '../shared/components/Ads'
import { redGreenGradient } from '../shared/gradients'
import { GroupRow } from './types'

interface GroupsPerformanceProps {
  rows: GroupRow[]
}

interface PeriodRow {
  ticker: string
  label: string
  group: string
  screenerUrl: string
  perf: number
}

class GroupsPerformance extends React.Component<GroupsPerformanceProps> {
  declare pageRef: ReturnType<typeof getInvestingChannelPage>

  componentDidMount() {
    this.pageRef = getInvestingChannelPage()
    this.pageRef.create()
  }

  componentWillUnmount() {
    this.pageRef?.destroy()
  }

  render() {
    const periodColumns = {
      d: 'perfT',
      w: 'perfW',
      m: 'perfM',
      q: 'perfQ',
      hy: 'perfH',
      y: 'perfY',
      ytd: 'perfYtd',
    }

    let data: Record<string, PeriodRow[]> = {}
    Object.keys(periodColumns).forEach((period) => {
      data[period] = this.props.rows.map((row) => ({
        ticker: row.ticker,
        label: row.label,
        group: row.group,
        screenerUrl: row.screenerUrl,
        // @ts-ignore
        perf: row[periodColumns[period]],
      }))
    })

    return (
      <div className="flex">
        <div className="flex-1" />
        <div>
          {Object.keys(periodColumns).map((period) => (
            <GroupsBarChart key={period} rows={data[period]} period={period} />
          ))}
        </div>
        <div className="flex-1">
          <AdTag name="IC_Groups" className="sticky hidden sticky-8 xl:block" />
        </div>
      </div>
    )
  }
}

interface GroupsBarChartProps {
  period: string
  rows: PeriodRow[]
}

class GroupsBarChart extends React.Component<GroupsBarChartProps> {
  state = {
    rows: this.props.rows,
    hoveredGroup: null,
  }

  componentDidMount() {
    // setInterval(() => {
    //     d3.json('/api/futures_perf.ashx' + window.location.search, (error, data) => {
    //         if (!error) {
    //             this.setState({rows: data});
    //         }
    //     });
    // }, 30 * 1000);
  }

  render() {
    const isRedesign = !!FinvizSettings.hasRedesignEnabled
    var hoveredGroup = this.state.hoveredGroup
    var rows = this.state.rows
      .map(function (row) {
        return {
          label: row.label,
          value: row.perf,
          isInactive: hoveredGroup !== null && hoveredGroup !== row.group,
        }
      })
      .sort(function (a, b) {
        return b.value - a.value
      })

    return (
      <div
        className={classnames('futures', {
          'pt-2.5': isRedesign,
        })}
      >
        <BarChart
          width={740}
          barHeight={16}
          data={rows}
          onClick={this._onBarClick}
          period={this.props.period}
          gradient={isRedesign ? redGreenGradient : undefined}
          alignHeaderToBars={isRedesign}
          isHorizontal
        />
      </div>
    )
  }

  _onBarClick = (bar: { label: string; value: number; isInactive?: boolean }) => {
    const screenerUrl = this.state.rows.filter((tile) => tile.label === bar.label)[0].screenerUrl
    window.open(screenerUrl)
  }
}

export default GroupsPerformance
